import { NgModule } from '@angular/core';
import { CommonModule } from "@angular/common";

import { PageRoutingModule } from "./page-routing.module";

import { SharedModule } from 'app/shared/shared.module';
import { MyStatusComponent } from './my-status/my-status.component';
import { MyActivitiesComponent } from './my-activities/my-activities.component';
import { ActivitiesSupervisorComponent } from './activities-supervisor/activities-supervisor.component';
import { ActivitiesAuditorComponent } from './activities-auditor/activities-auditor.component';
import { NgbRatingModule } from '@ng-bootstrap/ng-bootstrap';
import { DoCheckPointComponent } from './do-check-point/do-check-point.component';
import { CalificationsComponent } from './califications/califications.component';
import { ScorecardComponent } from './scorecard/scorecard.component';
import { TimelineMonitorComponent } from './timeline-monitor/timeline-monitor.component';


@NgModule({
  imports: [
    CommonModule,
    PageRoutingModule,
    SharedModule,
    NgbRatingModule
  ],
  exports: [],
  declarations: [
    MyStatusComponent,
    MyActivitiesComponent,
    ActivitiesSupervisorComponent,
    ActivitiesAuditorComponent,
    DoCheckPointComponent,
    CalificationsComponent,
    ScorecardComponent,
    TimelineMonitorComponent
  ],
  providers: [],
})
export class PageModule { }
